import { useState } from 'react'

const ITEMS = [
  { key: 'estado', label: 'Mi estado'},
  { key: 'miperfil', label: 'Mi perfil'},
  { key: 'sialgopasa', label: '🆘 SOS'},
  { key: 'mispersonas', label: 'Mis personas' },
  { key: 'miscuentas', label: 'Mis cuentas'},
  { key: 'mascotas', label: 'Mascotas'},
  { key: 'checklist', label: 'Checklist' },
  { key: 'cartas', label: 'Cartas' },
  { key: 'mihistoria', label: 'Mi historia' },
  { key: 'alerta', label: 'Estoy bien' },
  { key: 'instrucciones', label: 'Guía de uso' },
  { key: 'seguridad', label: 'Privacidad y acceso'},
]

function Navbar({ usuario, onLogout, paginaActiva, onCambiarPagina }) {
  const [menuAbierto, setMenuAbierto] = useState(false)

  return (
    <>
      {/* CSS para desktop/móvil */}
      <style>{`
        .sidebar { display: flex; }
        .topbar-movil { display: none; }
        .menu-movil-overlay { display: none; }
        .contenido-principal {
          margin-left: 220px;
          min-height: 100vh;
          width: calc(100% - 220px);
          max-width: calc(100% - 220px);
          overflow-x: hidden;
        }
        @media (max-width: 768px) {
          .sidebar { display: none !important; }
          .topbar-movil { display: flex !important; }
          .contenido-principal {
            margin-left: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            
          }
          .menu-movil-overlay.abierto { display: flex !important; }
        }
      `}</style>

      {/* SIDEBAR DESKTOP */}
      <div className="sidebar" style={estilos.sidebar}>
        <div style={estilos.sidebarLogo} onClick={() => window.location.href = '/'}>
          <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logoImg} />
          <span style={estilos.logoNombre}>ETERN-ME</span>
        </div>

        <nav style={estilos.sidebarNav}>
          {ITEMS.map(item => (
            <button
              key={item.key}
              onClick={() => onCambiarPagina(item.key)}
              style={{
                ...estilos.sidebarBtn,
                backgroundColor: paginaActiva === item.key ? 'rgba(196,168,130,0.15)' : 'transparent',
                color: item.key === 'sialgopasa' ? '#E57373' : paginaActiva === item.key ? '#FAF8F5' : '#C4A882',
                fontWeight: item.key === 'sialgopasa' ? '700' : paginaActiva === item.key ? '600' : '400',
                fontSize: item.key === 'sialgopasa' ? '14px' : '13px',
                borderLeft: paginaActiva === item.key ? '3px solid #C4A882' : item.key === 'sialgopasa' ? '3px solid #E57373' : '3px solid transparent',
              }}
            >
              <span style={estilos.sidebarIcono}>{item.icono}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div style={estilos.sidebarFooter}>
          <div style={estilos.sidebarEmail}>{usuario}</div>
          <button onClick={onLogout} style={estilos.sidebarSalir}>Salir</button>
        </div>
      </div>

      {/* TOPBAR MÓVIL */}
      <div className="topbar-movil" style={estilos.topbar}>
        <div style={estilos.topbarMarca} onClick={() => window.location.href = '/'}>
          <img src="/logo-circulo.png" alt="Etern-me" style={estilos.topbarLogo} />
          <span style={estilos.topbarNombre}>ETERN-ME</span>
        </div>
        <button style={estilos.hamburguesa} onClick={() => setMenuAbierto(!menuAbierto)}>
          {menuAbierto ? '✕' : '☰'}
        </button>
      </div>

      {/* MENÚ MÓVIL OVERLAY */}
      <div
        className={`menu-movil-overlay ${menuAbierto ? 'abierto' : ''}`}
        style={estilos.menuOverlay}
      >
        <div style={estilos.menuMovil}>
          <div style={estilos.menuMovilHeader}>
            <span style={estilos.menuMovilEmail}>{usuario}</span>
            <button onClick={() => setMenuAbierto(false)} style={estilos.menuMovilCerrar}>✕</button>
          </div>
          {ITEMS.map(item => (
            <button
              key={item.key}
              onClick={() => { onCambiarPagina(item.key); setMenuAbierto(false) }}
              style={{
                ...estilos.menuMovilBtn,
                backgroundColor: paginaActiva === item.key ? 'rgba(196,168,130,0.15)' : 'transparent',
                color: item.key === 'sialgopasa' ? '#E57373' : paginaActiva === item.key ? '#FAF8F5' : '#E8D5B7',
                fontWeight: item.key === 'sialgopasa' ? '700' : paginaActiva === item.key ? '700' : '400',
                fontSize: item.key === 'sialgopasa' ? '16px' : '15px',
                borderLeft: paginaActiva === item.key ? '3px solid #C4A882' : item.key === 'sialgopasa' ? '3px solid #E57373' : '3px solid transparent',
              }}
            >
              <span style={{ marginRight: '12px' }}>{item.icono}</span>
              {item.label}
            </button>
          ))}
          <div style={estilos.menuMovilDivider} />
          <button onClick={() => { onLogout(); setMenuAbierto(false) }} style={estilos.menuMovilSalir}>
            Salir
          </button>
        </div>
      </div>
    </>
  )
}

const estilos = {
  // SIDEBAR
  sidebar: {
    position: 'fixed', top: 0, left: 0, bottom: 0, width: '220px',
    backgroundColor: '#2C1810', borderRight: '1px solid #3D2418',
    flexDirection: 'column', zIndex: 100, overflowY: 'auto',
  },
  sidebarLogo: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '20px 16px', cursor: 'pointer', borderBottom: '1px solid #3D2418',
    flexShrink: 0,
  },
  logoImg: { width: '32px', height: '32px', borderRadius: '50%', objectFit: 'contain', flexShrink: 0 },
  logoNombre: { color: '#FAF8F5', fontSize: '14px', fontWeight: '700', letterSpacing: '0.5px' },
  sidebarNav: { flex: 1, padding: '12px 0', display: 'flex', flexDirection: 'column' },
  sidebarBtn: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '11px 16px', border: 'none', cursor: 'pointer',
    fontSize: '13px', textAlign: 'left', transition: 'all 0.15s ease',
    width: '100%',
  },
  sidebarIcono: { fontSize: '16px', flexShrink: 0, width: '20px', textAlign: 'center' },
  sidebarFooter: {
    padding: '16px', borderTop: '1px solid #3D2418', flexShrink: 0,
  },
  sidebarEmail: { fontSize: '11px', color: '#8B6F47', marginBottom: '10px', wordBreak: 'break-all' },
  sidebarSalir: {
    width: '100%', padding: '8px', backgroundColor: 'transparent',
    border: '1px solid #8B6F47', color: '#C4A882', borderRadius: '6px',
    fontSize: '13px', cursor: 'pointer',
  },

  // TOPBAR MÓVIL
  topbar: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    backgroundColor: '#2C1810', borderBottom: '1px solid #3D2418',
    height: '56px', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 16px', width: '100%',
  },
  topbarMarca: { display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' },
  topbarLogo: { width: '28px', height: '28px', borderRadius: '50%', objectFit: 'contain' },
  topbarNombre: { color: '#FAF8F5', fontSize: '14px', fontWeight: '700', letterSpacing: '0.5px' },
  hamburguesa: {
    backgroundColor: 'transparent', border: 'none',
    color: '#FAF8F5', fontSize: '22px', cursor: 'pointer', padding: '4px 8px',
  },

  // MENÚ MÓVIL
  menuOverlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 200,
    flexDirection: 'row', alignItems: 'stretch',
  },
  menuMovil: {
    width: '280px', backgroundColor: '#2C1810',
    display: 'flex', flexDirection: 'column', overflowY: 'auto',
  },
  menuMovilHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '16px', borderBottom: '1px solid #3D2418',
  },
  menuMovilEmail: { fontSize: '12px', color: '#8B6F47', flex: 1, marginRight: '8px', wordBreak: 'break-all' },
  menuMovilCerrar: { backgroundColor: 'transparent', border: 'none', color: '#C4A882', fontSize: '18px', cursor: 'pointer' },
  menuMovilBtn: {
    display: 'flex', alignItems: 'center',
    padding: '13px 16px', border: 'none', cursor: 'pointer',
    fontSize: '15px', textAlign: 'left', width: '100%',
  },
  menuMovilDivider: { height: '1px', backgroundColor: '#3D2418', margin: '4px 0' },
  menuMovilSalir: {
    backgroundColor: 'transparent', border: 'none',
    color: '#E57373', padding: '14px 16px',
    fontSize: '15px', cursor: 'pointer', textAlign: 'left', width: '100%',
  },
}

export default Navbar